import { gate } from 'hub-http/gates';
export const AGENT_INBOX_GLOBAL_NAV = gate('AIRuntime::AgentInbox::GlobalNav');
export const CREATE_AGENT = gate('Workflows:ModernEditor');
export const CREATE_AGENT_AS_STARTER_PORTAL = gate('Breeze:AgentAccessStarterHoldover');
export const WORKFLOWS_MODERN_EDITOR = gate('Workflows:ModernEditor');
export const TOOLS_AUDIT = gate('AgentBuilder:ToolsAudit');
export const BROKEN_WORKFLOWS_WARNING = gate('AgentBuilder:BrokenWorkflowsWarning');
export const CUSTOM_ASSISTANT_CREATION = gate('BreezeAssistant:CustomAssistant:Creation');
export const ALLOW_DRAFT_AGENTS_IN_WORKFLOWS = gate('AgentBuilder:AllowDraftAgentsInWorkflows');
export const UNPUBLISH_AGENTS = gate('AgentBuilder:UnpublishAgents');
export const AGENT_PLAN_MODE_INTERACTIVITY = gate('AgentBuilder:PlanModeInteractivity');
export const AUTOMATIONS_SETTINGS = gate('AgentBuilder:AutomationsSettings');
export const CONVERSATIONAL_SCHEDULED_WORKFLOWS = gate('AgentBuilder:ConversationalScheduledWorkflows');
export const AGENT_QUALITY_RECOMMENDATION_SKILL = gate('AgentQuality:RecommendationSkillGate');
export const AGENT_TEST_MODE_INTERACTIVITY = gate('AgentBuilder:InteractiveTesting');
export const BREEZE_ENGINE_UI = gate('BreezeEngine:EngineUI');
export const USER_TYPE_AGENTS = gate('UserManagement::UserTypes::Agents');
export const AGENT_GOALS_RECOMMENDATIONS = gate('KnowledgeVault:AgentGoalsRecommendations');
export const AGENTS_AT_STARTER = gate('AgentBuilder:AgentsAtStarter');
export const UNIFIED_TOOLS_API = gate('AgentBuilder:UnifiedToolsAPI');
export const CUSTOM_AGENT_INVOCATION = gate('BreezeAssistant:CustomAgentInvocation');
export const VERSION_DIFF = gate('AgentBuilder:VersionDiff');
export const OBJECTIVE_INLINE_REFERENCES = gate('AgentBuilder:ObjectiveInlineReferences');